// The following code is copied from `packages/nextjs-core/src/api/app-context.ts`
// This is an incremental optimization that avoids coupling `@udemy/ud-api` with `@udemy/nextjs-core`
// This code will eventually be replace and deprecated with a `AppContextProvider` will can provide

export const APP_CONTEXT_VAR_NAME = '__UDMY_APP_CONTEXT';
export const APP_CONTEXT_VAR_PRESENT = '__UDMY_APP_CONTEXT_PRESENT';
export function isAppContextOnClientSupported() {
  if (global.window && global.window[APP_CONTEXT_VAR_PRESENT]) {
    return true;
  }
}
export async function getClientAppContext() {
  return new Promise(resolve => {
    function resolvePageContext() {
      const APP_CONTEXT = window[APP_CONTEXT_VAR_NAME];
      if (APP_CONTEXT) {
        resolve({
          data: APP_CONTEXT
        });
      } else {
        setTimeout(resolvePageContext, 100);
      }
    }
    resolvePageContext();
  });
}
//# sourceMappingURL=app-context.js.map